<template>
  <div class="login-page">
    <el-row type="flex"
            justify="end"
            align="middle"
            style="height: 100%;">
      <el-col class="login-box">
        <!-- <div class="line" /> -->
        <h1 class="login-box_title">标序云仓管理后台</h1>
        <div class="login-box_main">
          <div class="login-box-left_img">
            <img src="../../../src/assets/images/login/login_left.png">
          </div>
          <div class="login-box-form">
            <h2 class="login-box_chlidTitle">登录</h2>
            <el-form ref="form"
                     :model="form"
                     :rules="rules"
                     width="100%">
              <el-form-item prop="accout">
                <el-input v-model="form.accout"
                          placeholder="请输入登录账号"
                          class="user"
                          autocomplete="off"
                          @keyup.enter.native="submitForm('form')"></el-input>
              </el-form-item>
              <el-form-item prop="password">
                <el-input type="text"
                          v-model="form.password"
                          placeholder="请输入登录密码"
                          class="pwd"
                          autocomplete="off"
                          @keyup.enter.native="submitForm('form')"></el-input>
              </el-form-item>
              <el-form-item prop="code">
                <el-row>
                  <!-- 左侧盒子 -->
                  <el-col :span="17">
                    <el-input type="text"
                              placeholder="请输入验证码"
                              v-model="form.code"
                              class="verCode"
                              @keyup.enter.native="submitForm('form')"></el-input>
                  </el-col>
                  <el-col :span="7">
                    <!-- 验证码图片 -->
                    <Verification ref="verification_code"
                                  class="canvas"></Verification>
                  </el-col>
                </el-row>
              </el-form-item>
              <el-row type="flex"
                      justify="end">
                <el-col :span="6">
                  <el-checkbox v-model="checked"
                               @change="rememberPwd">记住密码</el-checkbox>
                </el-col>
              </el-row>
              <el-form-item style="padding-top:10px">
                <el-button type="primary"
                           class="submit"
                           @click="submitForm('form')">立 即 登 录</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </el-col>
      <div class="bottom">
        <div>
          <span>福建凌跃科技发展有限公司&nbsp;&nbsp;</span>
          <span>Copyright 2016-2017 All Right Reserved&nbsp;&nbsp;</span>
          <a class="keep-record" target="_blank" href="https://beian.miit.gov.cn">闽ICP备15018044号-3</a>
        </div>
      </div>
    </el-row>
  </div>
</template>
<script>
import {
  LOGIN
  // GETINFO
} from '../../store/user/types'
import user from '../../store/user/index'
import Verification from '../../components/Verification'

export default {
  name: 'login',
  components: {
    Verification
  },
  data () {
    return {
      schoolAvatar: null,
      checked: false,
      form: {
        accout: '',
        password: '',
        code: ''
      },
      rules: {
        accout: [
          { required: true, message: '请输入登录账号', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入登录密码', trigger: 'blur' }
        ],
        code: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ]
      },
      isDrop: true,
      drawer: false,
      search: ''
    }
  },
  computed: {
    // 学校列表
    schoolList () {
      return user.state.schoolList
    },
    // 搜索学校结果
    schoolListKeySeachResult () {
      let list = []
      for (let i = 0; i < this.schoolList.length; i++) {
        if (this.schoolList[i].name && this.schoolList[i].name.indexOf(this.search) !== -1) {
          list.push(this.schoolList[i])
        }
      }
      return list
    }
  },
  mounted () {
  },
  created () {
    if (this.getCookie('accout') && this.getCookie('password')) {
      this.form.accout = this.getCookie('accout')
      this.form.password = this.getCookie('password')
      this.checked = true
    }
  },
  methods: {
    rememberPwd (value) {
      if (value) {
        this.setCookie('accout', this.form.accout, 7) // 保存帐号到cookie，有效期7天
        this.setCookie('password', this.form.password, 7) // 保存密码到cookie，有效期7天
      } else {
        this.delCookie('accout')
        this.delCookie('password')
      }
    },
    getCookie (name) {
      var reg = RegExp(name + '=([^;]+)')
      var arr = document.cookie.match(reg)
      if (arr) {
        return arr[1]
      } else {
        return ''
      }
    },
    setCookie (name, value, day) {
      var date = new Date()
      date.setDate(date.getDate() + day)
      document.cookie = name + '=' + value + ';expires=' + date
    },
    delCookie (name) {
      this.setCookie(name, null, -1)
    },
    // getSchoolList () {
    //   this.$store.dispatch(SCHOOLLIST)
    // },
    drawerSchool () {
      this.drawer = true
    },
    handleClose (done) {
      this.drawer = false
      this.search = ''
    },
    drop (value) {
      this.isDrop = !value
    },
    submitForm (formName) {
      let vm = this
      if (this.$refs.verification_code.number === (this.form.code).toUpperCase()) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            // console.log(vm.form)
            // vm.form.schoolId = this.schoolId
            // vm.form.clientType = 1
            this.$store.dispatch(LOGIN, vm.form)
          } else {
            this.$notify({
              title: '提示',
              message: '请输入正确的用户名密码'
            })
          }
        })
      } else {
        this.$notify({
          title: '提示',
          message: '请输入正确的验证码'
        })
      }
    }
  }
}
</script>

<style scoped>
.login-page {
  background: url("../../../src/assets/images/login/bg.png") no-repeat center;
  background-size: cover;
  position: absolute;
  width: 100%;
  height: 100%;
}

.login-box {
  width: 800px;
  margin: 0 auto;
}

.login-box .line {
  width: 3.38vw;
  height: 0.41vw;
  background-color: #5baff1;
  margin-bottom: 1.92vw;
}

.login-box_title {
  color: #ffffff;
  /*margin-bottom: 1.14vw;*/
}

.login-box .select-school {
  display: flex;
  align-items: center;
  margin-bottom: 2.91vw;
}

.login-box .select-school_select {
  position: relative;
  color: #3a3a3a;
  font-size: 1.56vw;
  display: flex;
  align-items: center;
  font-weight: 300;
}

.login-box .select-school_select:hover {
  cursor: pointer;
}

.login-page .school-head {
  display: inline-block;
  width: 3.12vw;
  height: 3.12vw;
  border-radius: 50%;
  margin-right: 1.04vw;
  box-shadow: 0 3px 2px rgba(0, 0, 0, 0.14);
}

.login-box .select-school .el-select {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  opacity: 0;
}

.login-box .select-school .select-drop {
  width: 1.04vw;
  height: 0.62vw;
  transition: all 0.3s;
  margin-left: 0.4vw;
}

.login-box .select-school .select-droped {
  width: 1.04vw;
  height: 0.62vw;
  transition: all 0.3s;
  margin-left: 0.4vw;
  transform: rotate(180deg);
}

.login-page .el-input {
  width: 100% !important;
}

.submit {
  width: 388px;
  height: 48px;
  background-color: #199efd;
  border-radius: 24px;
  font-size: 20px;
  line-height: 14px;
  padding: 0;
  border: none;
  font-family: "Microsoft YaHei";
  margin-top: 8px;
}

.login-box_title {
  margin-bottom: 42px;
  font-size: 60px;
  font-weight: 400;
  color: #ffffff;
  text-shadow: 0px 2px 5px rgba(0, 0, 0, 0.18);
  text-align: center;
  font-family: "ShiShangZhongHeiJianTi";
}

.login-page .bottom {
  width: 100%;
  position: fixed;
  bottom: 0;
  color: #ffffff;
  font-size: 12px;
  padding: 7px 0 5px 0;
}

.login-page .bottom div {
  width: 558px;
  margin: 0 auto;
  /* display: flex; */
  justify-content: space-between;
  font-family: "Microsoft YaHei";
}

.login-page_text-gary {
  color: #aaaaaa;
}

/*2021-4-13更改*/
.login-box_chlidTitle {
  color: #222222;
  font-size: 30px;
  padding-left: 49px;
  padding-bottom: 29px;
}
.login-box-left_img {
  background: #0a8cbf;
  width: 304px;
  height: 415px;
  float: left;
}

.login-box_main {
  width: 800px;
  height: 415px;
}
.login-box-form {
  background: #fff;
  float: left;
  width: 464px;
  height: 383px;
  padding-left: 32px;
  padding-top: 32px;
  margin-bottom: 110px;
}
.canvas {
  position: absolute;
  left: 55%;
}
/*引用字体*/
@font-face {
  font-family: "ShiShangZhongHeiJianTi"; /*字体名称*/
  src: url("../../../src/assets/ttf/ShiShangZhongHeiJianTi.ttf"); /*字体源文件*/
}
.keep-record {
  color: #fff;
}
.keep-record:hover {
  text-decoration: underline
}
</style>



// WEBPACK FOOTER //
// src/page/login/Login.vue